/**
 * OpsChat "knowledge base" step: satisfied when legacy user-level fields exist, or
 * any unit has at least one knowledgeBase entry with real text (title or content).
 * Per-unit `knowledgeBase` is the source of truth for Leo; userInfo.* fields are legacy.
 */
function knowledgeBaseEntryHasSubstance(entry) {
  if (!entry || typeof entry !== "object") return false;
  const content = (entry.content && String(entry.content).trim()) || "";
  if (content.length > 0) return true;
  const title = (entry.title && String(entry.title).trim()) || "";
  if (title.length > 0 && title.toLowerCase() !== "new clause") return true;
  return false;
}

/**
 * @param {object} [userInfo] - Auth / Firestore user doc
 * @param {Array<object>} [units] - Owner's units (e.g. from unitModel or React Query)
 * @returns {boolean}
 */
export function hasLeoKnowledgeBaseContext(userInfo, units) {
  if (userInfo) {
    if (
      userInfo.leoKnowledgeBase ||
      userInfo.knowledgeBase ||
      userInfo.leoContext ||
      userInfo.chatKnowledgeBase
    ) {
      return true;
    }
  }
  if (!Array.isArray(units) || units.length === 0) return false;
  return units.some((u) => {
    const kb = u.knowledgeBase;
    if (!Array.isArray(kb) || kb.length === 0) return false;
    return kb.some(knowledgeBaseEntryHasSubstance);
  });
}
